var _defs, _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDmDoughnut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dummy-widget-doughnut-dm-cls-1 {\n        clip-path: url(#dm-doughnut-dummy-widget-doughnut-dm-clippath);\n      }\n\n      .dummy-widget-doughnut-dm-cls-2 {\n        fill: none;\n      }\n\n      .dummy-widget-doughnut-dm-cls-2, .dummy-widget-doughnut-dm-cls-3, .dummy-widget-doughnut-dm-cls-4, .dummy-widget-doughnut-dm-cls-5, .dummy-widget-doughnut-dm-cls-6, .dummy-widget-doughnut-dm-cls-7, .dummy-widget-doughnut-dm-cls-8, .dummy-widget-doughnut-dm-cls-9, .dummy-widget-doughnut-dm-cls-10 {\n        stroke-width: 0px;\n      }\n\n      .dummy-widget-doughnut-dm-cls-3 {\n        fill: #4eb062;\n      }\n\n      .dummy-widget-doughnut-dm-cls-4 {\n        fill: #e9e9ea;\n      }\n\n      .dummy-widget-doughnut-dm-cls-5 {\n        isolation: isolate;\n        opacity: .5;\n      }\n\n      .dummy-widget-doughnut-dm-cls-5, .dummy-widget-doughnut-dm-cls-11, .dummy-widget-doughnut-dm-cls-10 {\n        fill: #fff;\n      }\n\n      .dummy-widget-doughnut-dm-cls-12 {\n        clip-path: url(#dm-doughnut-dummy-widget-doughnut-dm-clippath-1);\n      }\n\n      .dummy-widget-doughnut-dm-cls-11 {\n        stroke: #c1c1c1;\n        stroke-miterlimit: 10;\n        stroke-width: .4px;\n      }\n\n      .dummy-widget-doughnut-dm-cls-6 {\n        fill: #f29c3f;\n      }\n\n      .dummy-widget-doughnut-dm-cls-7 {\n        fill: #e6e6e4;\n      }\n\n      .dummy-widget-doughnut-dm-cls-8 {\n        fill: #49beed;\n      }\n\n      .dummy-widget-doughnut-dm-cls-9 {\n        fill: #3463ac;\n      }\n\n      .dummy-widget-doughnut-dm-cls-13 {\n        display: none;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "dm-doughnut-dummy-widget-doughnut-dm-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-2",
    x: 7.4,
    y: 7.5,
    width: 155.2,
    height: 155.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dm-doughnut-dummy-widget-doughnut-dm-clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-dm-cls-2",
    d: "M85.4,52.6l-33.1,6.9c3.2,15.4,16.8,27,33.1,27s18-4.4,23.6-9.6l-23.6-24.4h0Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-4",
    y: 0,
    width: 170.1,
    height: 170.1,
    rx: 7.6,
    ry: 7.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-doughnut-dm-cls-1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-5",
    x: -72.2,
    y: 7.5,
    width: 98.3,
    height: 155.3,
    rx: 6.1,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-11",
    x: 38.6,
    y: 7.8,
    width: 93.4,
    height: 154.6,
    rx: 6.1,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-doughnut-dm-cls-6",
    cx: 54.7,
    cy: 117,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-doughnut-dm-cls-3",
    cx: 54.7,
    cy: 137,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-doughnut-dm-cls-8",
    cx: 54.7,
    cy: 127,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-doughnut-dm-cls-9",
    cx: 54.7,
    cy: 147,
    r: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-7",
    x: 59.7,
    y: 114.8,
    width: 38.1,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-7",
    x: 106.3,
    y: 114.8,
    width: 4.4,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-7",
    x: 111.8,
    y: 114.8,
    width: 7.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-7",
    x: 106.3,
    y: 124.9,
    width: 4.4,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-7",
    x: 111.8,
    y: 124.9,
    width: 7.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-7",
    x: 106.3,
    y: 134.8,
    width: 4.4,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-7",
    x: 111.8,
    y: 134.8,
    width: 7.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-7",
    x: 106.3,
    y: 144.8,
    width: 4.4,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-7",
    x: 111.8,
    y: 144.8,
    width: 7.7,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-7",
    x: 59.7,
    y: 124.9,
    width: 29,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-7",
    x: 59.7,
    y: 134.8,
    width: 35.5,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-7",
    x: 59.7,
    y: 144.8,
    width: 38.1,
    height: 4.4,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-doughnut-dm-cls-13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-dm-cls-8",
    d: "M85.4,18.8c-18.7,0-33.8,15.2-33.8,33.9s15.1,33.8,33.8,33.8,33.8-15.2,33.8-33.8-15.1-33.9-33.8-33.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-dm-cls-3",
    d: "M96.3,20.6l-10.9,32.1,32.7,8.9c.8-2.8,1.2-5.8,1.2-8.9,0-14.9-9.6-27.5-23-32.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-dm-cls-9",
    d: "M85.4,52.6l23.6,24.3c4.3-4.2,7.5-9.5,9.1-15.4,0,0-32.7-8.9-32.7-8.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-dm-cls-6",
    d: "M85.4,52.6l-33.1,6.9c3.2,15.4,16.8,26.9,33.1,26.9s17.5-3.7,23.6-9.6l-23.6-24.3h0Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-doughnut-dm-cls-10",
    cx: 85.4,
    cy: 52.7,
    r: 23.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-dm-cls-8",
    d: "M85.4,18.8c-18.7,0-33.8,15.2-33.8,33.9s15.1,33.8,33.8,33.8,33.8-15.2,33.8-33.8-15.1-33.9-33.8-33.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-dm-cls-3",
    d: "M96.3,20.6l-10.9,32.1,32.7,8.9c.8-2.8,1.2-5.8,1.2-8.9,0-14.9-9.6-27.5-23-32.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-dm-cls-9",
    d: "M85.4,52.6l23.6,24.3c4.3-4.2,7.5-9.5,9.1-15.4,0,0-32.7-8.9-32.7-8.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-doughnut-dm-cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-dm-cls-6",
    d: "M85.4,18.8c-18.7,0-33.8,15.2-33.8,33.9s15.1,33.8,33.8,33.8,33.8-15.2,33.8-33.8-15.1-33.9-33.8-33.9Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    className: "dummy-widget-doughnut-dm-cls-10",
    cx: 85.4,
    cy: 52.7,
    r: 23.4
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-5",
    x: 145.1,
    y: 7.5,
    width: 98.3,
    height: 72.3,
    rx: 6.1,
    ry: 6.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-doughnut-dm-cls-5",
    x: 145.1,
    y: 89.8,
    width: 98.3,
    height: 72.3,
    rx: 6.1,
    ry: 6.1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-doughnut-dm-cls-6",
    d: "M47.9-64.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmDoughnut);
export default __webpack_public_path__ + "static/media/dm_doughnut.a5b41482.svg";
export { ForwardRef as ReactComponent };